<template>
    <div class="container">
        <div class="row">
            <div class="col-12 col-sm-6 col-md-4">
                <h4>Groups</h4>
                <button class="btn btn-sm btn-cph-primary-outline"
                        @click="addNewGroup">
                    Add new
                </button>
                <button class="btn btn-sm btn-primary"
                        @click="exportData">
                    Export templates
                </button>
                <button class="btn btn-sm btn-default"
                        @click="importTemplateData">
                    Import templates
                </button>
                <button class="btn btn-sm btn-danger"
                        @click="deleteAll">
                    Delete template groups
                </button>
                <template-list :list="templateGroups"
                               displayKey="label"
                               @select="selectGroup"
                               @handleDeletion="handleGroupDeletion">
                    <template slot-scope="slotProps">
                        <span class="badge badge-primary badge-pill cursor-pointer"
                              @click="checkTemplates(slotProps.option)">
                            Check templates
                        </span>
                    </template>
                </template-list>
            </div>
            <template-group-edition class="col-12 col-sm-6 col-md-4"
                                    @add="addGroup"
                                    @save="saveGroup"
                                    :mode="mode"
                                    :group.sync="selectedGroup"
                                    v-if="selectedGroup && !showTemplates">
            </template-group-edition>
            <div class="col-12 col-sm-6 col-md-4" v-else-if="showTemplates">
                Templates in group: {{selectedGroup.label}}
                <template-list :list="templateList"
                               displayKey="description">
                    <template slot-scope="slotProps">
                        <span class="badge badge-primary badge-pill cursor-pointer"
                              @click.stop="editTemplate(slotProps.option)">
                            Edit
                        </span>
                    </template>
                </template-list>
            </div>
        </div>
        <input type="file" ref="fileInput" class="hidden-input">
    </div>
</template>

<script type="text/babel">
import { mapGetters, mapActions, mapMutations } from 'vuex';
import TemplateGroupEdition from './TemplateGroupEdition';
import TemplateList from '../TemplatesEditor/TemplateList';
import ImportMixin from '../../../../mixins/importMixin.vue';

export default {
    name: 'TemplateGroups',
    data () {
        return {
            selectedGroup: null,
            mode: '',
            showTemplates: false,
            templateList: []
        };
    },
    components: {
        TemplateGroupEdition,
        TemplateList
    },
    mixins: [ImportMixin],
    computed: {
        ...mapGetters({
            templateGroups : 'getTemplateGroups'
        })
    },
    methods: {
        ...mapActions([
            'addTemplateGroupAsync',
            'removeTemplateGroupAsync',
            'updateTemplateGroupAsync',
            'getTemplateGroupsAsync',
            'getTemplatesByGroupIds',
            'deleteAllGroups',
            'getTemplateByTemplateIdAsync'
        ]),
        ...mapMutations(['addTemplateGroup', 'addAlert']),
        async exportData () {
            try {
                await this.exportTemplates();
            } catch (err) {
                this.addAlert({
                    title: 'Failed ',
                    type: 'danger',
                    body: 'to export templates'
                });
                throw new Error(err);
            }
        },
        importTemplateData () {
            this.importAll(this.$refs.fileInput, this.importTemplates, {});
        },
        selectGroup (group) {
            this.showTemplates = false;
            this.mode = 'edition';
            this.selectedGroup = group;
        },
        addNewGroup () {
            this.mode = 'addition';
            this.selectedGroup = {
                label: '',
                id: this.$utils.shortid.generate()
            };
        },
        async deleteAll () {
            try {
                await this.$utils.resolvePromises(this.templateGroups.map(group => this.handleGroupDeletion(group, true)));
                await this.getTemplateGroupsAsync();
            } catch (err) {
                this.$store.commit('addAlert', {
                    title: 'Failed ',
                    type: 'danger',
                    body: 'to remove all groups'
                });
                throw new Error(err);
            }
            
        },
        resetSelectedGroup () {
            this.selectedGroup = null;
            this.groupHasChanged = false;
            this.mode = '';
        },
        async addGroup () {
            await this.addTemplateGroupAsync(this.selectedGroup);
            this.getTemplateGroupsAsync();
            this.resetSelectedGroup();
        },
        saveGroup () {
            this.updateTemplateGroupAsync(this.selectedGroup);
            this.getTemplateGroupsAsync();
            this.resetSelectedGroup();
        },
        async handleGroupDeletion (group, noFetch) {
            try {
                let {data} = await this.removeTemplateGroupAsync(group);
                if(!noFetch) {
                    await this.getTemplateGroupsAsync();
                }
                this.showTemplates = false;
                this.selectedGroup = null;
                return {data};
            } catch (err) {
                this.$store.commit('addAlert', {
                    title: 'Failed ',
                    type: 'danger',
                    body: 'to delete group'
                });
                throw new Error(err);
            }
        },
        async getTemplates (arrayOfPromises) {
            try {
                return await this.$utils.resolvePromises(arrayOfPromises);
            } catch (err) {
                this.$store.commit('addAlert', {
                    title: 'Failed ',
                    type: 'danger',
                    body: 'to get all templates'
                });
                throw new Error(err);
            }
        },
        editTemplate (template) {
            this.$emit('changeTab', {name: 'templates', data: template});
        },
        async checkTemplates (group) {
            this.selectedGroup = group;
            let {id} = group;
            let {data} = await this.getTemplatesByGroupIds(id);
            let promiseRes = await this.$utils.resolvePromises(
                data.map(id => this.getTemplateByTemplateIdAsync({id}))
            );
            this.templateList = this.$utils.flatten(promiseRes);
            this.showTemplates = true;
        }
    },
    created () {
        this.getTemplateGroupsAsync();
    }
};

</script>

<style lang="scss" scoped>

</style>
